import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {toggleCollapsedSideNav} from "../../../appRedux/actions/Setting";
import IntlMessages from "util/IntlMessages";

const NoHeaderNotification = () => {

  const dispatch = useDispatch();
  const { navCollapsed} = useSelector(({common}) => common);

  return (
    <div className="gx-no-header-horizontal">
      <div className="gx-d-block gx-d-lg-none gx-linebar gx-mr-xs-3">
        <button type="button" className="gx-icon-btn icon icon-menu"
           aria-label="Toggle navigation"
           style={{
             background: 'none', border: 'none', padding: 0, margin: 0,
             font: 'inherit', color: 'inherit', textAlign: 'inherit', cursor: 'pointer',
             display: 'inline-flex', alignItems: 'center',
           }}
           onClick={() => {
             dispatch(toggleCollapsedSideNav(!navCollapsed));
           }}
        />
      </div>
      <div className="gx-no-header-horizontal-top">
        <div className="gx-no-header-horizontal-top-center">
          <i className="icon icon-alert gx-mr-3"/>
          <p className="gx-mb-0 gx-text-truncate"><IntlMessages id="app.announced"/></p>
        </div>
      </div>
    </div>
  )
};

export default NoHeaderNotification;
